export default __webpack_public_path__ + "static/media/valet-addon.c1921ad1.svg";